export const Status = {
  NONE: 0,
  PENDING: 1,
  SUCCESS: 2,
  FAILURE: 3
};
